import * as React from "react";
import { Timestamp } from "components/common";
import EventDefinitionName from "views/components/widgets/events/filters/EventDefinitionName";
import EventTypeLabel from "components/events/events/EventTypeLabel";
import PriorityName from "components/events/events/PriorityName";
const eventsAttributes = [
  {
    attribute: "timestamp",
    displayValue: (value) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value }),
    sortable: true,
    title: "Created At"
  },
  {
    attribute: "alert",
    displayValue: (value) => /* @__PURE__ */ React.createElement(EventTypeLabel, { isAlert: value }),
    sortable: true,
    title: "Type"
  },
  {
    attribute: "event_definition_id",
    displayValue: (value) => /* @__PURE__ */ React.createElement(EventDefinitionName, { eventDefinitionId: value }),
    sortable: true,
    title: "Event Definition"
  },
  {
    attribute: "priority",
    displayValue: (value) => /* @__PURE__ */ React.createElement(PriorityName, { priority: value }),
    sortable: true,
    title: "Priority"
  },
  {
    attribute: "key",
    title: "Key"
  },
  {
    attribute: "message",
    title: "Description"
  }
];
export default eventsAttributes;
